<template>
  <div class="toast" :class="{ [type]: type }">
    <div class="toast__bg animation-start" :style="{ animationDuration: animationDuration + 's' }"></div>
    <div class="toast__content">
      <div class="toast__content__icon">
        <div class="toast__content__icon__inner">
          <img v-if="type" :src="icon" alt="icon" />
        </div>
      </div>
      <div class="toast__content__text">
        <div class="toast__content__text__title">{{ title }}</div>
        <div class="toast__content__text__description">{{ description }}</div>
      </div>

      <div class="toast__close" @click="handleClose">
        <Icon name="/base/close.svg" />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Base/Icon/Icon.vue'

export default {
  name: 'ToastNotification',
  components: {
    Icon
  },
  props: {
    type: {
      type: String,
      default: 'success',
      validator: value => ['success', 'error', 'warning'].includes(value)
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: null
    },
    delay: {
      type: Number,
      default: null
    }
  },
  computed: {
    icon() {
      const icons = {
        success: require('./images/success.svg'),
        error: require('./images/error.svg'),
        warning: require('./images/warning.svg')
      }
      return icons[this.type]
    },

    animationDuration() {
      return (this.delay / 1000).toString()
    }
  },
  methods: {
    handleClose() {
      this.$store.commit('notification/resetNotification', this.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './toast';
</style>
